import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import { fetchSets, addSets, sortSets, searchSets, filterSets } from "../../actions/settings"
import SetsCompItem from "./SetsCompItem"
import SetsAddCompForm from "./SetsAddCompForm"
import isEmpty from 'lodash/isEmpty'
import { sortOpts } from '../../utils/utils'

class SetsComp extends React.Component {

  state = {adding: false}

  componentWillMount(){
    this.props.fetchSets('comp');
    this.props.fetchSets('ctype');
    this.props.fetchSets('srvg');
  }

  startAdding = () => {
    this.setState({adding: true});
  }

  cancelAdding = () => {
    this.setState({adding: false});
  }

  clearSearch = () => {
    if(this.props.comps.search !== ''){
      this.props.searchSets('comp','');
    }
  }

  handleSearch = e => {
    const searchQuery = e.target.value.toLowerCase();
    this.props.searchSets('comp', searchQuery);
  }

  changeSort = asc => {
    if(asc === 0)
      return 1
    return 0
  }

  handleSort = sortField => {
    const currField = this.props.comps.sort.field;
    const currAsc = this.props.comps.sort.asc;
    const asc = sortField === currField ? this.changeSort(currAsc) : 1;
    this.props.sortSets('comp',{field:sortField,asc:asc});
  }

  handleTypeFilter = e => {
    // e.preventDefault();
    // console.log(e);
    this.props.filterSets('comp',{
      ...this.props.comps.filter,
      type: e.value
    });
  }

  handleCtypeFilter = (e, type) => {
    this.props.filterSets('comp',{
      ...this.props.comps.filter,
      ctype: e
    });
  }

  handleSrvgFilter = e => {
    if (!e) {
      this.props.filterSets('comp', {
        ...this.props.comps.filter,
        srvg: null
      });
    }
    else {
      this.props.filterSets('comp', {
        ...this.props.comps.filter,
        srvg: e.value
      });
    }
  }

  render() {
    if(isEmpty(this.props.comps.data)
      || isEmpty(this.props.srvgs)
      || isEmpty(this.props.ctypes)
    ){
      return(<div>Не загружены данные</div>);
    }
    const comps = this.props.comps.data;
    const { comps: { search, sort, filter }, srvgs, ctypes, srvmId } = this.props;

    var fltrComps = [];
    for(var key in comps){
      if(comps.hasOwnProperty(key) && comps[key].comp_active === 1){
        var found = true;
        var typeFiltered = true;
        var ctypeFiltered = true;
        var srvgFiltered = true;
        const compSrvgIdsArray = comps[key].comp_srvg_ids.split(',');
        if(search !== ''){
          const searchValue = "" + comps[key].comp_desc + comps[key].comp_long
            + comps[key].comp_addr + comps[key].comp_tel + comps[key].comp_email
            + comps[key].comp_note;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(filter.type !== '' && comps[key].hasOwnProperty("comp_"+filter.type)){
          typeFiltered = comps[key]["comp_"+filter.type] === 1;
        }
        if(filter.ctype !== ''){
          ctypeFiltered = filter.ctype.split(',').indexOf(""+comps[key].comp_ctype_id) !== -1;
        }
        if(filter.srvg) {
          srvgFiltered = compSrvgIdsArray.findIndex(el => el === filter.srvg) !== -1;
        }
        if(found && typeFiltered && ctypeFiltered && srvgFiltered){
          fltrComps.push(comps[key]);
        }
      }
    }

    const srtComps = fltrComps.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.comp_id < b.comp_id)
         return sort.asc ? -1 : 1
      if(a.comp_id > b.comp_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const srvgsOpt = [];
    for (let key in srvgs){
      if(
        srvgs.hasOwnProperty(key) &&
        srvgs[key].srvg_active === 1 &&
        srvgs[key].srvg_srvm_id === srvmId
      ) {
        srvgsOpt.push({value:key,label:srvgs[key].srvg_desc});
      }
    }
    srvgsOpt.sort(sortOpts);

    const ctypesOpt = [];
    for (let key in ctypes){
      if(
        ctypes.hasOwnProperty(key) &&
        ctypes[key].ctype_active === 1
      ) {
        ctypesOpt.push({value:key,label:ctypes[key].ctype_desc});
      }
    }
    ctypesOpt.sort(sortOpts);

    const mappedComps = srtComps ? srtComps.map(comp =>
      <SetsCompItem key={comp.comp_id}
        data={comp}
        srvgs={srvgs}
        ctypes={ctypes}
      />
    ) : [];

    const clearSearchBtn = <button
        type="button"
        className="btn btn-default"
        onClick={this.clearSearch}
        title="Очистить поиск">
        X
      </button>;

    const addNew = this.state.adding ?
      <SetsAddCompForm
        addSets={this.props.addSets}
        onCancel={this.cancelAdding}
        srvgs={srvgs}
        ctypes={ctypes}
        data={{
          comp_desc: '',
          comp_long: '',
          comp_city: '',
          comp_addr: '',
          comp_tel: '',
          comp_email: '',
          comp_note: '',
          comp_own: 0,
          comp_order: 1,
          comp_expense: 0,
          comp_cost: 0,
          comp_empl: 0,
          comp_ctype_id: 0,
          comp_srvg_ids: '',
          comp_active: 1
        }}
      />
      : [];


    return (
      <div>
        <h3 className="pull-right">Настройка контрагентов</h3>
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              {clearSearchBtn}
            </div>
          </div>{" "}
          <div className="input-group">{fltrComps.length} записей</div>
        </div>
        <div className="form-group form-inline">
          <div className="input-group" style={{zIndex: 2}}>
            <Select
              style={{width:'230px'}}
              options={srvgsOpt}
              value={filter.srvg}
              onChange={this.handleSrvgFilter}
              placeholder="Услуги"
            />
          </div>{" "}
          <div className="input-group" style={{zIndex: 2}}>
            <Select
              style={{width:'230px'}}
              options={ctypesOpt}
              value={filter.ctype}
              onChange={this.handleCtypeFilter}
              placeholder="Категория"
              simpleValue
              multi
            />
          </div>
          <div className="input-group" style={{zIndex: 2}}>
            <Select
              style={{width:'230px'}}
              options={[
                {value: '', label: 'Все'},
                {value: 'order', label: 'Клиенты'},
                {value: 'cost', label: 'Подрядчики'},
                {value: 'expense', label: 'Издержки'},
                {value: 'empl', label: 'Сотрудники'}
              ]}
              value={filter.type}
              onChange={this.handleTypeFilter}
              clearable={false}
            />
          </div>
        </div>
        {addNew}
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th className="col-xs-2"
                onClick={() => {this.handleSort('comp_desc')}}>Краткое название</th>
              <th className="col-xs-2">Группы услуг</th>
              <th className="col-xs-3"
                onClick={() => {this.handleSort('comp_note')}}>Описание</th>
              <th className="col-xs-2"
                onClick={() => {this.handleSort('comp_addr')}}>Адрес</th>
              <th className="col-xs-2">
                <span onClick={() => {this.handleSort('comp_tel')}}>Телефон, </span>
                <span onClick={() => {this.handleSort('comp_email')}}>Email</span>
              </th>
              <th className="col-xs-1"
                onClick={() => {this.handleSort('comp_long')}}>Название для печатных форм</th>
            </tr>
          </thead>
          <tbody>
            {mappedComps}
            <tr onClick={this.startAdding}>
              <td><u>Нажмите, чтобы добавить компанию</u></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    comps: store.comps,
    srvgs: store.srvgs.data,
    ctypes: store.ctypes.data,
    srvmId: store.settings.comp_sets_srvm_id
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets, searchSets, filterSets })(SetsComp);



// WEBPACK FOOTER //
// ./src/components/settings/SetsComp.js